
import React, { useState } from 'react'
import { Form, Link } from 'react-router-dom'
import FloatingLabelInput from 'react-floating-label-input';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
// import { FcGoogle } from "react-icons/fc";
import { SignInImages } from '../config/imagesLink';
import WarningToast from "./WarningToast";
import ErrorToast from "./ErrorToast";
import SuccessToast from "./SuccessToast";
import axios from '../API/axios'
// import SignInImages from '../config/imagesLink'
const ConfirmAccount = () => {

    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);
          const language = localStorage.getItem("Lang");


    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);

    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);

    //************************ Confirm Acount Start  ************************//
    const [mail, setMail] = useState('')
    const ConfirmAccount = async () => {
        const data = {
            deviceType: "Web",
            email: mail,
           langKey: language === "en" ? "" : language,

        };
        try {
            await axios.post("OAuth/ConfirmAccountByEmail", data).then((resData) => {
                console.log("resData", resData);
                setToastMessage(resData.data.message);
                setShowToast(true);
            });
        } catch (e) {
            if (e.response && e.response.status === 404) {
                setWarningToastMessage(e.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(e.response.data.message);
                setShowErrorToast(true);
            }
        }
    };
    //************************ Confirm Acount End  ************************//

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-8 full-height p-2 loginImage">
                        <div className="bg-cover">
                            <div className='imageData'>
                                <div className='text-center'>
                                    <img src={SignInImages.whiteLogo} alt="" />
                                </div>
                                <p>Stay connected for <a href="#" className='border-bottom'>Jobs</a>  & <a href="#" className='border-bottom'>More</a></p>
                                <div className='text-center mt-4'>
                                    <img src={SignInImages.ovalwithtext} alt="" width='80%' />
                                </div>
                            </div>
                            <div className="linksHelp">
                                <p><a href="#">Privacy Policy</a> | <a href="#">Terms and Condition</a></p>
                                <p>Having Troubles? <a href="#" className='border-bottom me-3'>Get Help</a> </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4  p-2">
                        <div className="form-container full-height pb-3 pt-5">
                            <Form>
                                <h2 className='header'>Confirm Account</h2>
                                <p className='paraClass1 mt-4 mb-4'>Enter your email to receive an email to confirm your account</p>

                                <FloatingLabelInput
                                    id="email"
                                    label="Registered Email address"
                                    type="text"
                                    value={mail}
                                    onChange={(e) => {
                                        setMail(e.target.value)
                                    }}
                                />
                                {/* <div className='checker d-flex align-items-center mt-2'>
                                    <input
                                        type="checkbox"
                                        id="terms"
                                        name="register_checkbox"
                                        value={mail}
                                        onChange={(e) => {
                                            setMail(e.target.value)
                                        }}
                                    // onBlur={handleBlur}
                                    />
                                    <p className='ms-2'>By clicking Create account, I agree that I have read and accepted the Terms of Use and Privacy Policy.</p>
                                </div> */}
                                <div className="my-4  text-center">
                                    <button type='submit' className='mainBtn' onClick={ConfirmAccount}>Send</button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>

            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
        </>
    )
}

export default ConfirmAccount